export enum UserLoginState {
  default,
  logined,
}

export interface SignInInfo {
  email: Email;
  password: Password;
}

export interface ResetInfo {
  code: string;
  password: Password;
}

export interface PasswordInfo {
  currentPassword: Password;
  newPassword: Password;
}

export interface ConfirmInfo {
  newPassword: Password;
  confirmPassword: Password;
}

interface UserDto {
  readonly id: number;
  readonly identifier: string;
  readonly name: string;
  readonly phone: string;
  readonly category: string;
  readonly serial: string;
}

interface User {
  readonly email: Email;
  readonly loginState: UserLoginState;
}

export const userFromDto = (userDto: UserDto): User => {
  return { email: userDto.identifier, loginState: UserLoginState.default };
};

export default User;
